import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiButtonGroup from '@material-ui/core/ButtonGroup';
import { styled, useThemeProps } from '../../../foundation';
import { RcButtonDefaultSize, RcButtonDefaultColor, RcButtonDefaultVariant, } from '../Button';
var _RcButtonGroup = forwardRef(function (inProps, ref) {
    var rest = __rest(useThemeProps({ props: inProps, name: 'RcButtonGroup' }), []);
    return (React.createElement(MuiButtonGroup, __assign({ ref: ref, size: RcButtonDefaultSize, color: RcButtonDefaultColor, variant: RcButtonDefaultVariant }, rest)));
});
var RcButtonGroup = styled(_RcButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export { RcButtonGroup };
var templateObject_1;
